import { Button, Flex, Menu, useMantineTheme } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import type { ReactNode } from 'react';

interface Props {
	color: string;
	children?: ReactNode;
}

export const InvestmentButtonMenu = ({ color, children }: Props) => {
	const theme = useMantineTheme();

	return (
		<Menu width={240} shadow="md" position="bottom-end" withinPortal>
			<Menu.Target>
				<Button
					variant="default"
					styles={{
						root: {
							minWidth: '2.5rem',
							borderColor: color,
							borderLeftColor: `${theme.colors.dark[8]}`,
							borderRadius: '0 0.25rem 0.25rem 0',
							background: color,
							'&:hover': {
								background: color,
							},
						},
					}}
				>
					<Icon variant="caret-down" size="lg" color="white" />
				</Button>
			</Menu.Target>

			<Menu.Dropdown
				sx={(theme) => ({
					boxShadow: '0px 16px 32px 0px #DCDFE0',
					borderColor: theme.colors.gray[0],
				})}
			>
				<Flex gap="0.25rem" direction="column">
					{children}
				</Flex>
			</Menu.Dropdown>
		</Menu>
	);
};
